"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _ui = require("@alycecom/ui");

var _classnames = _interopRequireDefault(require("classnames"));

var _utils = require("@alycecom/utils");

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var spacing = _ref.spacing,
      palette = _ref.palette;
  return {
    label: {
      color: palette.common.black,
      fontWeight: 'bold',
      marginRight: spacing(0.5),
      fontSize: 12
    },
    campaignTitle: {
      textTransform: 'capitalize',
      fontWeight: 'normal',
      color: palette.link.main
    },
    avatar: {
      borderRadius: '50%',
      width: 40,
      height: 40,
      border: "2px solid ".concat(palette.common.white),
      boxShadow: '0 2px 8px 0 rgba(0, 0, 0, 0.1)',
      color: palette.common.white,
      marginRight: spacing(2),
      marginLeft: spacing(1),
      paddingTop: spacing(1),
      textAlign: 'center'
    },
    avatarWithCheck: {
      background: palette.link.main
    },
    selectedName: {
      fontWeight: 'bold'
    },
    hoverUnderlineName: {
      '&:hover $campaignTitle': {
        textDecoration: 'underline'
      }
    },
    summary: {
      transition: 'font-weight 100ms',
      '&:hover': {
        cursor: 'pointer',
        '& $campaignTitle': {
          fontWeight: 'bold'
        }
      }
    },
    noHover: {
      '&:hover': {
        cursor: 'default',
        '& $campaignTitle': {
          textDecoration: 'none',
          fontWeight: 'normal'
        }
      }
    }
  };
});

/**
 * It gets the full campaign name.
 * If the campaign name contains more than 1 word,
 * it returns the first letter from the first two words.
 * If the campaign name contains one word, it returns its first
 * two characters.
 * Example: 'My Campaign' -> 'MC'
 *          'Campaign' -> 'CA'
 *          'Example Campaign Name' -> 'EC'
 * @param {string} - campaignName
 * @returns string
 */
var getAvatarText = function getAvatarText(campaignName) {
  if (campaignName.length < 2) {
    return campaignName.toLocaleUpperCase();
  }

  var splitTitle = campaignName.split(' ');
  var avatarText = '';

  if (splitTitle.length > 1) {
    avatarText = "".concat(splitTitle[0][0]).concat(splitTitle[1][0]);
  } else {
    avatarText = campaignName.substring(0, 2);
  }

  return avatarText.toLocaleUpperCase();
};

var CampaignSummary = function CampaignSummary(_ref2) {
  var name = _ref2.name,
      teamName = _ref2.teamName,
      campaignId = _ref2.campaignId,
      _ref2$isActive = _ref2.isActive,
      isActive = _ref2$isActive === void 0 ? false : _ref2$isActive,
      underlineTextHover = _ref2.underlineTextHover,
      noHover = _ref2.noHover;
  var classes = useStyles({
    underlineTextHover
  });

  var _useState = (0, _react.useState)(),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      avatar = _useState2[0],
      setAvatar = _useState2[1];

  (0, _react.useEffect)(function () {
    if (!avatar) {
      var color = (0, _utils.getRandomColor)('#fff');
      setAvatar(color);
    }
  }, [avatar]);
  return /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    alignItems: "center"
  }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true
  }, isActive ? /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: (0, _classnames.default)(classes.avatar, classes.avatarWithCheck)
  }, /*#__PURE__*/_react.default.createElement(_ui.Icon, {
    icon: "check"
  })) : /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: classes.avatar,
    style: {
      background: avatar
    }
  }, getAvatarText(name))), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    xs: true,
    container: true,
    className: (0, _classnames.default)(classes.summary, {
      [classes.hoverUnderlineName]: underlineTextHover,
      [classes.noHover]: noHover
    })
  }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    xs: true,
    container: true,
    direction: "column"
  }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    xs: true,
    zeroMinWidth: true
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: (0, _classnames.default)(classes.campaignTitle, {
      [classes.selectedName]: isActive
    }),
    "data-testid": "CampaignCardSummary.".concat(campaignId, ".Name")
  }, name)), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    item: true
  }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: classes.label
  }, "Team:")), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "caption",
    noWrap: true,
    "data-testid": "CampaignCardSummary.".concat(campaignId, ".TeamName")
  }, teamName))))));
};

var _default = /*#__PURE__*/(0, _react.memo)(CampaignSummary);

exports.default = _default;